import { z } from "zod";
import { notificationCategorySchema } from "@/features/notifications/schemas/notification.schema";

/// URL search-params schema for `/$workspaceSlug/notifications`.
/// `status` is the tab dimension (all/unread/read); `category` is an
/// optional second-axis filter.
export const NOTIFICATION_STATUSES = ["all", "unread", "read"] as const;
export type NotificationStatusFilter = (typeof NOTIFICATION_STATUSES)[number];

export const notificationsRouteSearchSchema = z
  .object({
    status: z.enum(NOTIFICATION_STATUSES).catch("all").default("all"),
    category: notificationCategorySchema.optional(),
  })
  .strict();
export type NotificationsRouteSearch = z.infer<typeof notificationsRouteSearchSchema>;
